import { render } from "./decorate.vue?vue&type=template&id=14d3e8b6&scoped=true"
import script from "./decorate.vue?vue&type=script&lang=js"
export * from "./decorate.vue?vue&type=script&lang=js"

import "./decorate.vue?vue&type=style&index=0&id=14d3e8b6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d3e8b6"],['__file',"src/views/dragger/decorate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14d3e8b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14d3e8b6', __exports__)) {
    console.log('reload')
    api.reload('14d3e8b6', __exports__)
  }
  
  module.hot.accept("./decorate.vue?vue&type=template&id=14d3e8b6&scoped=true", () => {
    console.log('re-render')
    api.rerender('14d3e8b6', render)
  })

}


export default __exports__